import Tabs from "../ui-components/Tabs";
import IconButton from "../ui-components/IconButton";
import Button from "../ui-components/Button";
import { CheckIcon, PlusCircleIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/solid";;
import {FormattedMessage, useIntl} from "react-intl";
import AuthenticationService from "../services/AuthenticationService";
import Modal from "../ui-components/Modal";
import Alert from "../ui-components/Alert";
import { useState } from "react";

const ConfirmApproveModal = ({onExit, onConfirm}) => {
  return <Modal
    onExit={onExit}
    >
    <div className="p-5">
      <Alert
        type="warning"
        title={
          <FormattedMessage
            id="warning_approve_draft_version"
            defaultMessage="Attenzione, una volta approvata la versione le nuove configurazioni nei cantieri verrano create usando quest'ultima."
          />
        }
      />
      <p className={"my-2"}>
        <FormattedMessage
          id="confirm_approve_draft_version"
          defaultMessage="Sei sicuro di voler approvare la versione?"
        />
      </p>
    </div>
    <div className="flex w-full justify-center gap-x-2">
      <Button
        styleType="full"
        onClick={onConfirm}
      >
        <FormattedMessage
          id="confirm"
          defaultMessage="Conferma"
        />
      </Button>
      <Button
        styleType="empty"
        onClick={onExit}
      >
        <FormattedMessage
          id="cancel"
          defaultMessage="Annulla"
        />
      </Button>
      </div>
  </Modal>
}

const ConfirmDeleteModal = ({onExit, onConfirm}) => {
  return <Modal
    onExit={onExit}
    >
    <div className="p-5">
      <Alert
        type="warning"
        text={
          <FormattedMessage
            id="warning_delete_draft_version"
            defaultMessage="Attenzione, una volta eliminata la versione non sarà possibile recuperarla."
          />
        }
      />
      <p>
        <FormattedMessage
          id="confirm_delete_draft_version"
          defaultMessage="Sei sicuro di voler eliminare la versione?"
        />
      </p>
    </div>
    <div className="flex w-full justify-center gap-x-2">
      <Button
        styleType="red"
        onClick={onConfirm}
      >
        <FormattedMessage
          id="confirm"
          defaultMessage="Conferma"
        />
      </Button>
      <Button
        styleType="empty"
        onClick={onExit}
      >
        <FormattedMessage
          id="cancel"
          defaultMessage="Annulla"
        />
      </Button>
    </div>
  </Modal>
}

export const ServiceConfiguratorVersionManager = (
  {
    versions,
    versionsWithNew,
    setCurrentVersion,
    currentVersion,
    service,
    newVersion,
    setNewVersion,
    approveDraftVersion,
    deleteDraftVersion,
    setSubmitting,
  }
) => {

  // hooks
  const intl = useIntl();
  const userScopes = AuthenticationService.getUserScopes();

  // utils
  const userCanCreateNewVersion = userScopes.includes("service:create_new_version");
  const canCreateNewVersion = userCanCreateNewVersion && newVersion === null && versions[versions.length - 1] === service?.active_version;
  const userCanApproveNewVersion = userScopes.includes("service:approve_new_version");
  const userCanDeleteNewVersion = userScopes.includes("service:delete_new_version");
  const newVersionIsSaved = newVersion === null && versions[versions.length - 1] !== service.active_version;
  const isVersionApprovingEnabled = userCanApproveNewVersion && newVersionIsSaved;
  const isVersionDeletingEnabled = userCanDeleteNewVersion && (!canCreateNewVersion || newVersionIsSaved);
  const isCurrentVersionLast = currentVersion === versionsWithNew[versionsWithNew.length - 1];
  const tabsDiv = document.getElementById("versions-tabs");

  // state
  const [isOpenApproveModal, setIsOpenApproveModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

  if (tabsDiv  && currentVersion === versionsWithNew[versionsWithNew.length - 1])
    tabsDiv.scrollTo(tabsDiv.scrollWidth,0);

  return <>{versions ?
    <>
      <div className={"grid grid-cols-1 gap-y-5"}>
        <FormattedMessage id="steps_versions" defaultMessage="Versioni degli step" />
        <div className={"flex gap-x-5 align-items-center mb-2"}>
          <Tabs
            setActiveTab={(i) => {
              if (newVersion !== null && i !== versionsWithNew.indexOf(newVersion)) {
                setNewVersion(null);
              }
              setCurrentVersion(versionsWithNew[i]);
            }}
            active={versionsWithNew.indexOf(currentVersion)}
            wFull={false}
            tabsDivId={"versions-tabs"}
            tabs={
              versionsWithNew.map((i) => {
                const isActive = i === service.active_version
                const isDraftSaved = !isActive && newVersion === null && i === versions[versions.length - 1]
                const isDraftNotSaved = newVersion !== null && i === newVersion
                const label = isActive
                  ? intl.formatMessage({id: "active_version", defaultMessage: "attiva"})
                  : isDraftSaved
                    ? intl.formatMessage({id: "draft_saved", defaultMessage: "bozza salvata"})
                    : isDraftNotSaved
                      ? intl.formatMessage({id: "draft_not_saved", defaultMessage: "bozza non salvata"})
                      : null;
                return {name: label ?`${i} (${label})`:`${i}`}
              })
            }
          />
          {canCreateNewVersion ? <IconButton
              disabled={!canCreateNewVersion}
              Icon={PlusCircleIcon}
              onClick={() => {
                const nv = versions[versions.length - 1] + 1
                setNewVersion(nv);
                setCurrentVersion(nv)
              }}
            >
              <FormattedMessage id={"new_version"} defaultMessage={"Nuova"}/>
            </IconButton> :
            <div className={"flex gap-x-2"}>
              {isVersionApprovingEnabled && isCurrentVersionLast &&
                <IconButton
                  styleType="greenWhite"
                  onClick={() => {
                    setIsOpenApproveModal(true)
                  }}
                  // onClick={() => {
                  //   setSubmitting(true)
                  //   try {
                  //     approveDraftVersion()
                  //   } catch (error) {
                  //     console.log(error)
                  //   }
                  //   setSubmitting(false)
                  // }}
                  Icon={CheckIcon}
                />
              }
              {isVersionDeletingEnabled && isCurrentVersionLast &&
                <IconButton
                  styleType="redWhite"
                  onClick={() => {
                    if (newVersion !== null) {
                      setNewVersion(null)
                      setCurrentVersion(service.active_version)
                    } else
                      setIsOpenDeleteModal(true)
                  }}
                  // onClick={async () => {
                  //   if (newVersion !== null) {
                  //     setNewVersion(null)
                  //     setCurrentVersion(service.active_version)
                  //   } else {
                  //     setSubmitting(true)
                  //     try {
                  //       await deleteDraftVersion()
                  //     } catch (error) {
                  //       console.log(error)
                  //     }
                  //     setSubmitting(false)
                  //   }
                  // }}
                  Icon={TrashIcon}
                />
              }
            </div>
          }
        </div>
      </div>

    </> : null}
    {isOpenApproveModal &&
      <ConfirmApproveModal
        onExit={() => setIsOpenApproveModal(false)}
        onConfirm={() => {
          setSubmitting(true)
          try {
            approveDraftVersion()
          } catch (error) {
            console.log(error)
          }
          finally {
            setIsOpenApproveModal(false)
          }
          setSubmitting(false)
          setIsOpenApproveModal(false)
        }}
      />
    }
    {isOpenDeleteModal &&
      <ConfirmDeleteModal
        onExit={() => setIsOpenDeleteModal(false)}
        onConfirm={async () => {
          setSubmitting(true)
          try {
            await deleteDraftVersion()
          } catch (error) {
            console.log(error)
          }
          finally {
            setIsOpenDeleteModal(false)
          }
          setSubmitting(false)
        }}
      />
    }
  </>
}